export default "__VITE_ASSET__CtEDUGU8__"